export const IS_BIKE_FOR_SALE_FILTER_SHORT_NAME = "purchasable"
export const isBikeForSaleDefault = false

const sN = IS_BIKE_FOR_SALE_FILTER_SHORT_NAME
const dV = isBikeForSaleDefault

export const IS_BIKE_FOR_SALE_FILTER_CONFIG = {
  short_name: sN,
  default_values: dV,
  is_default: value => testIsBikeForSaleDefault(value), //right before clean up
  format_to_api: value => formatIsBikeForSaleForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatIsBikeForSaleFromURL(value) //
}

export const formatIsBikeForSaleFromURL = value => {
  if (typeof value === 'boolean') {
    return value
  }

  return value === 'true' ? true : false
}

export const testIsBikeForSaleDefault = value => {
  if (value !== isBikeForSaleDefault) {
    return false
  }
  return true
}

//api
export const formatIsBikeForSaleForAPI = value => {
  if (value) {
    return {
      purchasable: value
    }
  } else {
    return {}
  }
}